import React from 'react';
import ReactDOM from 'react-dom/client';
import "react-datepicker/dist/react-datepicker.css";
import App from './App';
import './assets/css/fonts.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);